import React from 'react'
import { useSwitchLms } from './useSwitchLms'

const SwitchLms = () => {
	const { renderDialogSwitchLms } = useSwitchLms()
	return <div>{renderDialogSwitchLms()}</div>
}

export default React.memo(SwitchLms)
